import React from 'react';
import PropTypes from 'prop-types';
import DefaultSelectV2 from '../DefaultSelectV2';

/** Alinha com DefaultSelectV2: opção vazia para '' evita warning de valor fora do Select e mostra placeholder. Use `showEmpty={false}` só quando o valor sempre for "true"|"false". */
const TrueFalseSelectV2 = ({
  error,
  label,
  name,
  onChange,
  value,
  disabled,
  isRequired,
  showEmpty = true,
}) => (
  <DefaultSelectV2
    error={error}
    disabled={disabled}
    handlerOption={(option) => option.descricao}
    isRequired={isRequired}
    label={label}
    name={name}
    options={[
      { id: 'true', descricao: 'Sim' },
      { id: 'false', descricao: 'Não' },
    ]}
    onSelect={onChange}
    showEmpty={showEmpty}
    value={value}
  />
);

TrueFalseSelectV2.propTypes = {
  error: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  isRequired: PropTypes.any,
  showEmpty: PropTypes.bool,
};
TrueFalseSelectV2.defaultProps = { value: '', onChange: () => {}, showEmpty: true };
export default TrueFalseSelectV2;
